import { createPersistedStore, storage } from '@connect-x-app/hybrid-utils';
import { MessageMention } from '@connect-x-app/shared-domain-models';
import { createJSONStorage } from 'zustand/middleware';

type ExternalMentionsState = {
  externalMentions: MessageMention[];
  setExternalMentions: (externalMentions: MessageMention[]) => void;
};

export const useExternalMentionsStore = createPersistedStore<ExternalMentionsState>(
  (set, _) => ({
    externalMentions: [],
    setExternalMentions: externalMentions => {
      set(_ => ({
        externalMentions,
      }));
    },
  }),
  {
    name: 'external-mentions-store',
    storage: createJSONStorage(() => storage),
  },
);
